import React from 'react';
import { Link } from 'react-router-dom';

import { getClickAttrs } from '../../Analytics/gtag';
import { clickCategories, clickLocations } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';
import TrackedClick from '../../Analytics/TrackedClick';

import styles from '../header.scss';

const DesktopLink = ({ label, to, navId, isActive }) => {
    return (
        <div className={`${styles.navLink} ${isActive ? 'active' : ''}`}>
            <TrackedClick
                eventName="Header CTA Clicked"
                label={label}
                traits={{
                    container: clickCategories.HEADER,
                    uxType: 'link',
                    content: label,
                }}
            >
                <Link
                    className="underline"
                    to={to}
                    {...getClickAttrs({
                        category: clickCategories.HEADER,
                        context: label,
                        location: clickLocations.HEADER_CTA,
                        testid: `${navigationIDs[navId].component}-${navigationIDs[navId].location}-${navigationIDs[navId].id}`,
                    })}
                >
                    {label}
                </Link>
            </TrackedClick>
        </div>
    );
};

export default DesktopLink;
